import React from "react";

import "./index.scss";

const Intro = () => {
  return (
    <>
      <div className="container pt-2">
        <div className="section-header pt-5 text-center">
          <h3 className="section-title">
            <span>公司 </span>简介
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto">
            深圳市洪德茂实业有限公司自2000年成立以来携手世界一流轴
            承制造商，持续完善供应链管理，以优势品牌为核心，构建高效、
            多层次、结构完善的产品供应体系，精诚服务国内终端客户和渠
            道客户，使各种类型客户能够以较低成本获得多元的优质轴承供
            应和专业的服务支持。
            深圳市洪德茂实业有限公司是UBC轴承中国一级代理商，AXPB直
            线导轨中国一级代理商，KML中国一级代理商，同时兼营SKF、FAG、
            NSK、NTN、NICHI、IKO、KOYO、EASE、IJK、INA、ASAHI、FYH等
            国内外知名品牌轴承，以及导轨滑块，光轴、油脂、轴承油封配件等。
          </h6>
        </div>
      </div>

      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>公司 </span>优势
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto">
            品牌齐全 经验丰富
          </h6>
          <h6 className="section-subtitle mr-auto ml-auto">
            以优势品牌为核心，构建高效、多层次、结构完善的产
            品供应体系，经营UBC、KML、UTE、SKF、FAG、NSK、
            NTN、NACHI、IKO、KOYO、EASE、IJK、INA、ASAHI、FYH
            等国内外知名品牌轴承。
          </h6>
          <h6 className="section-subtitle mr-auto ml-auto">
            库存保障 供货及时
          </h6>
          <h6 className="section-subtitle mr-auto ml-auto">
            我们公司现有四万多种现货安全库存，品种
            齐全，供货及时，可为各地经销商提供良好的 供货和服务保障。
            充分地满足了客户在特殊型号及大批量需求 方面的要求。
          </h6>
          <h6 className="section-subtitle mr-auto ml-auto">全方位服务保障</h6>
          <h6 className="section-subtitle mr-auto ml-auto">
            对于终端客户，我们公司专业技术团队可直接到客户
            现场，为客户提供技术支持。从轴承选型到出样品，都
            有专业技术人员提供全方位服务。
            根据客户需求提供优质的全方位配套解决方案。
          </h6>
        </div>
      </div>
    </>
  );
};

export default Intro;
